import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { OrganizationInfoConfig } from 'src/app/core/models/organization-info-configuration';

@Injectable({
  providedIn: 'root'
})
export class OrganizationInfoCreateModalService extends BaseModalService<OrganizationInfoConfig> {}
